import { render, staticRenderFns } from "./detail-echart.vue?vue&type=template&id=01425b61&"
import script from "./detail-echart.vue?vue&type=script&lang=ts&"
export * from "./detail-echart.vue?vue&type=script&lang=ts&"
import style0 from "./detail-echart.vue?vue&type=style&index=0&id=01425b61&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports